
export class ImportoProgetto{
    id:number;
    anno:number;
    importo:number;    
}